import { render, staticRenderFns } from "./PixabayPicker.vue?vue&type=template&id=12567471&scoped=true"
import script from "./PixabayPicker.vue?vue&type=script&lang=js"
export * from "./PixabayPicker.vue?vue&type=script&lang=js"
import style0 from "./PixabayPicker.vue?vue&type=style&index=0&id=12567471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12567471",
  null
  
)

export default component.exports